import React from "react"
import {FieldTableCellProps, FieldTableCellState, getTableCellStyle} from "../../../../../render/table/table-cell"
import User from "../../../../../../model2/user/user"
import UserIcon from "../../../../../../gd-components/icons/user/user"

// const debug = "FieldTimeReportUser_TableCell"
const debug = false

export default class FieldTimeReportUser_TableCell extends React.Component<FieldTableCellProps, FieldTableCellState> {

    constructor(props:FieldTableCellProps) {
        super(props)
    }

    renderValue(width: number) {

        const iconOnly:boolean = width<=80

        const value = _.get(this.props.listItem.item, this.props.field.fieldId, null)
        const userId = value?.[0]

        let user : User | null = null

        if (userId) {
            user = gd.session.users.get(userId)
        }

        if (!userId || !user) {

            if (iconOnly) {
                return <div></div>
            }

            return (
                <div>Select a user</div>
            )
        }



        if (iconOnly) {
            return (
                <div className="flex-row-center-center w-100-percent txt-truncate">
                    <UserIcon className="" userId={user.id} size="22"/>
                </div>
            )
        }

        return (
            <div className="flex-row-left-center w-100-percent txt-truncate">
                <UserIcon className="m-r-5" userId={user.id} size="22"/>
                <div className="max-w-100-percent txt-truncate">{user.name}</div>
            </div>
        )
    }

    render() {
        const classes = Classes("cell-flex ui5-field-editable size-small ui5-txt-less-important-small")

        const value = _.get(this.props.listItem.item, this.props.field.fieldId, null)
        const userId = value?.[0]
        const user = userId ? gd.session.users.get(userId) : null

        const style : style = getTableCellStyle(this.props)

        return (
            <div className  = {classes}
                 style      = {getTableCellStyle(this.props)}
            >

                {user && this.renderValue(style.width as number)}

            </div>
        )
    }
}



